import React from 'react';
import { USER_TYPE } from '@/shared/consts';
import { SignIn } from '../SignIn';

export const AdminSignIn: React.FC = () => {
  return <SignIn userType={USER_TYPE.ADMIN}>Fill in your credentials</SignIn>;
};
